import { ApplicationConfig, importProvidersFrom, provideExperimentalZonelessChangeDetection, provideZoneChangeDetection } from '@angular/core';
import { ExtraOptions, provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { getPerformance, providePerformance } from '@angular/fire/performance';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { AngularFireModule } from '@angular/fire/compat';
import { HttpClientModule } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";

const firebaseConfig = {
    projectId: "lionsgate-repository",
    appId: "1:971064101435:web:e8f8775c2554539ae5aa1e",
    storageBucket: "lionsgate-repository.firebasestorage.app",
    apiKey: "AIzaSyA1pTOXAp3DYsokGvMHrM62rsuFPiZS36M",
    authDomain: "lionsgate-repository.firebaseapp.com",
    messagingSenderId: "971064101435",
    measurementId: "G-H6LQEDYLH0"
}


const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'disabled',
};
// withRouterConfig(routerOptions),

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        // provideExperimentalZonelessChangeDetection(),
        provideRouter(
            routes,
            withInMemoryScrolling({
                scrollPositionRestoration: 'top',  // Scrolls to (0,0) on every navigation
                anchorScrolling: 'enabled'         // Optional: enables #fragment scrolling
            })
        ),
        provideNativeDateAdapter(),
        provideAnimations(),
        provideFirebaseApp(() => initializeApp(firebaseConfig)),
        provideAuth(() => getAuth()),
        provideAnalytics(() => getAnalytics()),
        ScreenTrackingService,
        UserTrackingService,
        provideFirestore(() => getFirestore()),
        provideMessaging(() => getMessaging()),
        providePerformance(() => getPerformance()),
        provideStorage(() => getStorage()),

        // ✅ Compat API - needed for AngularFireAuth, AngularFirestore, etc.
        importProvidersFrom(
            AngularFireModule.initializeApp(firebaseConfig)
        ),
        importProvidersFrom(HttpClientModule),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        },
    ],

};
